import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React from 'react';
import { Translate } from 'react-jhipster';

export const LogoutConfirmationModal = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { borderRadius: '8px', backgroundColor: 'primary.main', backgroundImage: 'none', padding: 2 } }}
      sx={{
        boxShadow:
          'rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px',
      }}
    >
      <DialogTitle sx={{ color: 'text.primary', pt: 0 }}>
        <Translate contentKey="entity.action.confirm">Confirm logout</Translate>
      </DialogTitle>
      <DialogContent sx={{ paddingBottom: 5 }}>
        <DialogContentText sx={{ color: 'text.primary' }}>
          <Translate contentKey="global.messages.confirmation">Are you sure you want to logout?</Translate>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onClose} color="secondary">
          <Translate contentKey="entity.action.cancel">Cancel</Translate>
        </Button>
        <Button variant="contained" onClick={onConfirm} color="error" autoFocus>
          <Translate contentKey="entity.action.exit">Confirm logout</Translate>
        </Button>
      </DialogActions>
    </Dialog>
  );
};
